import { Modal } from "../modal/modal";
import { ModalInfoProps, typedMemo } from "src/types";
import { Button } from "../button/button";
import { AlertCircleIcon } from "src/assets";
import { Image } from "react-bootstrap";

export const ModalInfo = typedMemo(
  ({
    title,
    message,
    confirmText,
    notConfirmText,
    visible,
    icon = AlertCircleIcon,
    iconClasses = "filter-light-blue",
    body,
    onClose,
    onNotConfirm,
    onConfirm,
  }: ModalInfoProps) => {
    return (
      <Modal
        visible={visible}
        onClose={onClose}
        classes="d-flex justify-content-center"
      >
        <div className="d-flex flex-column align-items-center text-center justify-content-center">
          {title && (
            <p className="text-center mb-4 mt-3 title-m--600 pre-line">
              {title}
            </p>
          )}
          <div className="p-1">
            <div className="d-inline ">
              {icon && <Image src={icon} width={80} className={iconClasses} />}
              {message && !body && (
                <p className="mb-4 mt-3 label-xxl pre-line">{message}</p>
              )}
              {!message && body}
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row gap-4">
            {notConfirmText && (
              <div className="d-flex align-items-center justify-content-center">
                <Button
                  text={notConfirmText}
                  flavor="primaryFlip"
                  classes="primary d-flex justify-content-center button-submit m-md-0"
                  classesText=""
                  classesIconRight="ms-2"
                  onPress={onNotConfirm}
                />
              </div>
            )}
            {confirmText && (
              <div className="d-flex align-items-center justify-content-center">
                <Button
                  text={confirmText}
                  flavor="primary"
                  classes="primary d-flex justify-content-center button-submit m-md-0"
                  classesText=""
                  classesIconRight="ms-2"
                  onPress={onConfirm}
                />
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
);
